import { IOrderLineReceiveInput } from '../models/receive-order-line.model';
import { normalizeOrderQuantity } from './normalize-order-quantity';

export function normalizeOrderLineReceiveBatches(
  batches: { quantity: number; expires?: Date | null }[] | undefined
): IOrderLineReceiveInput[] {
  return (batches ?? [])
    .map((batch) => ({
      quantity: normalizeOrderQuantity(batch.quantity),
      expires: batch.expires ?? undefined,
    }))
    .filter((batch) => batch.quantity > 0);
}

export function getOrderLineReceiveBatchesTotal(
  batches: { quantity: number }[] | undefined
): number {
  return normalizeOrderQuantity(
    normalizeOrderLineReceiveBatches(batches).reduce((total, batch) => total + batch.quantity, 0)
  );
}
